module.exports = __webpack_public_path__ + "static/media/arrow-up.d16280c2.svg";